module.exports = __webpack_public_path__ + "static/media/Logo__Salesforce.de8a4cff.svg";